
(() => {
  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(
        cents,
        window.Shopify.money_format
      ).replace(/<[^>]*>/g, "");
    }

    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: window.Shopify?.currency?.active || "INR",
      maximumFractionDigits: 2
    }).format(cents / 100);
  };

  let updateTimer;
  const popupTimers = new WeakMap();

  const updateBars = (cart) => {
    document.querySelectorAll("[data-wb-shipping-progress]").forEach((bar) => {
      const threshold = Number(bar.dataset.threshold || 59900);
      const total = Number(cart.total_price || 0);
      const remaining = Math.max(0, threshold - total);
      const unlocked = remaining <= 0;

      const progress = threshold > 0
        ? Math.min(100, (total / threshold) * 100)
        : 100;

      const message = bar.querySelector("[data-wb-progress-message]");
      const fill = bar.querySelector("[data-wb-progress-fill]");
      const track = bar.querySelector('[role="progressbar"]');
      const cartValue = bar.querySelector("[data-wb-cart-value]");
      const heading = bar.querySelector("[data-wb-progress-heading]");
      const popup = bar.querySelector(".wb-shipping-unlocked-popup");

      if (heading) {
        heading.textContent = unlocked
          ? "You're all set! 🎉"
          : "You're almost there! 🎉";
      }

      if (message) {
        message.replaceChildren();

        if (unlocked) {
          message.append("You've unlocked ");
          const strong = document.createElement("strong");
          strong.textContent = "FREE SHIPPING!";
          message.append(strong);
        } else {
          message.append("Add ");
          const amount = document.createElement("strong");
          amount.textContent = formatMoney(remaining);
          message.append(amount, " more to unlock ");
          const benefit = document.createElement("strong");
          benefit.textContent = "FREE SHIPPING";
          message.append(benefit);
        }
      }

      if (cartValue) {
        cartValue.textContent = formatMoney(total);
      }

      if (fill) {
        fill.style.width = `${progress}%`;
      }

      if (track) {
        track.setAttribute("aria-valuenow", String(Math.round(progress)));
      }

      const initialized = bar.dataset.wbUnlockInitialized === "true";
      const wasUnlocked = bar.dataset.wbWasUnlocked === "true";

      if (initialized && unlocked && !wasUnlocked && popup) {
        popup.classList.add("is-visible");
        popup.setAttribute("aria-hidden", "false");

        clearTimeout(popupTimers.get(bar));

        popupTimers.set(bar, setTimeout(() => {
          popup.classList.remove("is-visible");
          popup.setAttribute("aria-hidden", "true");
        }, 3500));
      }

      if (!unlocked && popup) {
        popup.classList.remove("is-visible");
        popup.setAttribute("aria-hidden", "true");
        clearTimeout(popupTimers.get(bar));
      }

      bar.dataset.wbWasUnlocked = String(unlocked);
      bar.dataset.wbUnlockInitialized = "true";
    });
  };

  const refreshCart = async () => {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        { headers: { Accept: "application/json" } }
      );

      if (!response.ok) return;

      updateBars(await response.json());
    } catch (error) {
      console.error("Shipping progress update failed:", error);
    }
  };

  const scheduleRefresh = () => {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(refreshCart, 700);
  };

  document.addEventListener("DOMContentLoaded", refreshCart);

  document.addEventListener("change", (event) => {
    if (event.target.closest("cart-drawer, cart-items, .cart")) {
      scheduleRefresh();
    }
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest(
      "cart-drawer button, cart-items button, .cart button, " +
      '[name="plus"], [name="minus"], .quantity__button, ' +
      "#wbStickyAddToCart"
    )) {
      scheduleRefresh();
    }
  });

  document.addEventListener("submit", (event) => {
    if (event.target.matches('form[action*="/cart/add"]')) {
      scheduleRefresh();
    }
  });

  [
    "cart:updated",
    "cart:refresh",
    "cart-drawer:updated",
    "product:added"
  ].forEach((eventName) => {
    document.addEventListener(eventName, scheduleRefresh);
  });

  document.addEventListener("toggle", (event) => {
    if (event.target.matches("cart-drawer")) {
      scheduleRefresh();
    }
  }, true);

  refreshCart();
})();
